import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Image from "../../../images/bg2.png";

const styles = {
  paperContainer: {
    height: 700,
    backgroundImage: `url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const WhoWeAre = () => {
  return (
    <Box style={styles.paperContainer} paddingTop={{ xs: "35%", sm: "8%" }}>
      <Box
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Typography
          variant="h4"
          color="#33E68C"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#000"
            fontWeight={800}
            variant={"h4"}
          >
            Who {""}
          </Typography>
          We Are
        </Typography>
      </Box>
      <Box
        width={{ xs: "100%", sm: "50%" }}
        padding={{ xs: "5% 1%", sm: "1% 3% 3% 0%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Typography
          variant={"body1"}
          fontWeight={500}
          textAlign={"left"}
          color={"#000"}
          data-aos={"fade-up"}
          lineHeight={"1.625em"}
        >
          <Typography
            component={"span"}
            color="#33E68C"
            fontWeight={800}
            lineHeight={"1.625em"}
          >
            ONDESIGN {""}
          </Typography>
          is not your traditional design agency. As a full-service digital
          agency, we design and develop digital products for clients across the
          world. We are a truly International digital agency. We don't create
          digital products that look great, but that which deliver the best user
          experience coupled with good rates.
        </Typography>
        <Typography
          variant={"body1"}
          fontWeight={500}
          textAlign={"left"}
          paddingTop={"2%"}
          color={"#000"}
          data-aos={"fade-up"}
          lineHeight={"1.625em"}
        >
          We also deliver digital services like Web and Mobile Applications
          Development, Full Services Branding, Infographics, Document Design and
          Printing, Animated Videos, Data Analysis and Surveys. Our
          project-managed approach sets us apart from many other digital
          agencies.
        </Typography>
      </Box>
    </Box>
  );
};

export default WhoWeAre;
